/**
 * 验证身份证有效性 - validateIdCard(idCard)
 * @param  {String}  idCard         身份证号码
 * @result {boolean} result         验证有效与否
 */
exports.validateIdCard = (idCard) => {
  // 15位和18位身份证号码的正则表达式
  var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/

  // 如果通过该验证，说明身份证格式正确，但准确性还需计算
  if (regIdCard.test(idCard)) {
    if (idCard.length === 18) {
      let idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 将前17位加权因子保存在数组里
      let idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]// 这是除以11后，可能产生的11位余数、验证码，也保存成数组
      let idCardWiSum = 0 // 用来保存前17位各自乖以加权因子后的总和
      for (let i = 0; i < 17; i++) {
        idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i]
      }

      let idCardMod = idCardWiSum % 11 // 计算出校验码所在数组的位置
      let idCardLast = idCard.substring(17) // 得到最后一位身份证号码

      // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if (idCardMod === 2) {
        if (idCardLast === 'X' || idCardLast === 'x') {
          return false
        } else {
          return true
        }
      } else {
        // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        if (idCardLast === idCardY[idCardMod].toString()) {
          return false
        } else {
          return true
        }
      }
    }
  } else {
    return true
  }
}
/**
 * 护照有效性 - validatePassport(passport)
 * @param  {String}  passport       护照
 * @result {boolean} result         验证有效与否
 */
exports.validatePassport = (passport) => {
  let re1 = /^[a-zA-Z]{5,17}$/
  let re2 = /^[a-zA-Z0-9]{5,17}$/
  if (re1.test(passport) || re2.test((passport))) {
    return false
  } else {
    return true
  }
}

/**
 * 港澳通行证有效性 - validatePermit(passport)
 * @param  {String}  permit         港澳通行证
 * @result {boolean} result         验证有效与否
 */
exports.validatePermit = (permit) => {
  let re = /^[WCGLTSQD]{1}([0-9]{10}|[0-9]{8})$/
  if (re.test(permit)) {
    return false
  } else {
    return true
  }
}

/**
 * 为空判断 - validateEmpty(str)
 * @param  {String}  str            内容
 * @result {boolean} result         验证有效与否
 */
exports.validateEmpty = (str) => {
  let re = /^\s*$/g
  if (re.test(str)) {
    return true
  } else {
    return false
  }
}
/**
 * 手机号码有效性 - validateTel(tel)
 * @param  {String}  tel            手机号码
 * @result {boolean} result         验证有效与否
 */
exports.validateTel = (tel) => {
  /* eslint-disable */
  let reCn = /^(\+?0?86\-?)?1[345789]\d{9}$/
  let reTw = /^(\+?886\-?|0)?9\d{8}$/
  /* eslint-enable */
  if (reCn.test(tel) || reTw.test(tel)) {
    return false
  } else {
    return true
  }
}

/**
 * 座机有效性 - validatePhone(tel)
 * @param  {String}  tel            座机号码
 * @result {boolean} result         验证有效与否
 */
exports.validatePhone = (tel) => {
  if (/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(tel)) {
    return false
  } else {
    return true
  }
}

/**
 * 台湾通行证有效性 - validateTwCard(card)
 * @param  {String}  card            台湾通行证
 * @result {boolean} result         验证有效与否
 */
exports.validateTwCard = (card) => {
  /* eslint-disable */
  let re1 = /^[T]{1}([0-9]{8})$/
  /* eslint-enable */
  if (re1.test(card)) {
    return false
  } else {
    return true
  }
}

/**
 * 获取字符串长度 getStringLength(str)
 * @param {String} string        字符串 | 一个中文两个字节，一个英文数字一个字节
 * @resuilt {boolean} result     字符串长度
 */
exports.getStringLength = (str) => {
  if (str) {
    var b = 0
    for (var c = 0; c < str.length; c++) {
      var d = str.charAt(c)
      // 判断是否为中文 \u0000-\u00ff 改为 \u4e00-\u9FA5
      b += /^[\u4e00-\u9FA5]$/.test(d) ? 1 : 2
    }
    return b
  }
}

/**
 * QQ有效性 - validateQQ(qq)
 * @param  {String}  qq             QQ号码
 * @result {boolean} result         验证有效与否
 */
exports.validateQQ = (qq) => {
  /* eslint-disable */
  let regQQ = /^[1-9][0-9]{4,}$/
  /* eslint-enable */
  if (regQQ.test(qq)) {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/utils/validator.js